import { ITabsProps } from '@cian/ui-kit/prev';
import { useSelector } from 'react-redux';

import { getInfrastructureFromBuilder, getTransportAccessibility } from '../../../../../selectors/newbuilding';
import { ETransportAccessibilityTab } from '../../../../../types/map';

export const useTransportAccessibilityTabs = () => {
  const transportAccessibility = useSelector(getTransportAccessibility);
  const infrastructureFromBuilder = useSelector(getInfrastructureFromBuilder);

  const tabs: ITabsProps['tabs'] = [];

  if (transportAccessibility) {
    tabs.push({
      value: ETransportAccessibilityTab.Outside,
      title: 'Рядом с ЖК',
    });
  }

  if (infrastructureFromBuilder) {
    tabs.push({
      value: ETransportAccessibilityTab.Inside,
      title: 'Внутри ЖК',
    });
  }

  return tabs;
};
